import _ from 'lodash'
import { createStructuredSelector } from 'reselect'

import {
  IIssue,
  IMaxThreads,
  IState,
  ITemperature,
} from './types'

const getBuildNumber = (state: IState): string => state.buildNumber
const getHardwareVariant = (state: IState): string => (state.datastore.values.find((row: string[]) => row![0] === 'ROOT/HW_VARIANT') || [null, ''])[1] as string
const getMaxThreads = (state: IState): IMaxThreads => state.maxThreads
const getSolsticeVersion = (state: IState): string => (state.datastore.values.find((row: string[]) => row![0] === 'ROOT/PRODUCT_VERSION') || [null, ''])[1] as string
const getStorage = (state: IState): string => state.storage.available
  ? `${state.storage.available}/${state.storage.total}MB (${state.storage.percent}) available`
  : 'Unknown'
const getTemperature = (state: IState): ITemperature => state.temperature

export const getIssues = (state: IState, ownProps: { keywords: string[] }) => {
  const result = state
    .issues
    .filter(issue => _.includes(ownProps.keywords, issue.type))
    .sort((a: IIssue, b: IIssue) => {
      if (a.type === 'TOMBSTONE_FILE') {
        return a.id > b.id ? 1 : -1
      }
      return a.lineNumber > b.lineNumber ? 1 : -1
    })
  return result
}

export const getMenuItems = createStructuredSelector({
  buildNumber: getBuildNumber,
  hardwareVariant: getHardwareVariant,
  maxThreads: getMaxThreads,
  solsticeVersion: getSolsticeVersion,
  storage: getStorage,
  temperature: getTemperature,
})



// WEBPACK FOOTER //
// ./src/selectors.ts